/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class t extends r{constructor(r,t,o){super(r,"mat4",0,(s,e)=>s.setUniformMatrix4fv(r,t(e),o))}}export{t as Matrix4BindUniform};
